export const MORE_GREEN = "MORE_GREEN";
export const MORE_RED = "MORE_RED";

export const MORE_BLUE = "MORE_BLUE";
export const MORE_YELLOW = "MORE_YELLOW";

export const LIGHTER = "LIGHTER";
export const DARKER = "DARKER";
